export default {
  claim: "The Ones Who Know",
  hero_text: "The Ones Who Know",
  white_list_button: "Connect your Metamask",
};
